import { CheckboxFilter } from '@lifebit-ai/lds'
import React from 'react'

import {
  ApprovedIcon,
  FailedIcon,
  IconContainer,
  PendingIcon,
  ProcessingIcon,
  RejectedIcon
} from 'modules/requests/filters/StatusFilter.styles'
import type { Option } from 'modules/types'
import { ImportRequestStatus } from 'services/import-requests/enums'

interface ImportRequestStatusFilterProps {
  onApply: (filteredOptions: Option[]) => void
  onReset: () => void
}

export const ImportRequestStatusFilter = ({ onApply, onReset }: ImportRequestStatusFilterProps) => {
  const options = [
    {
      label: 'Pending upload',
      value: ImportRequestStatus.PendingUpload,
      element: (
        <IconContainer>
          <PendingIcon />
          <span>Pending upload</span>
        </IconContainer>
      )
    },
    {
      label: 'Scanning',
      value: ImportRequestStatus.Scanning,
      element: (
        <IconContainer>
          <ProcessingIcon text={false} />
          <span>Scanning</span>
        </IconContainer>
      )
    },
    {
      label: 'Pending review (uploaded)',
      value: ImportRequestStatus.PendingVerification,
      element: (
        <IconContainer>
          <PendingIcon />
          <span>Pending review (uploaded)</span>
        </IconContainer>
      )
    },
    {
      label: 'Pending review (external)',
      value: ImportRequestStatus.Pending,
      element: (
        <IconContainer>
          <PendingIcon />
          <span>Pending review (external)</span>
        </IconContainer>
      )
    },
    {
      label: 'Copying source',
      value: ImportRequestStatus.CopyingExternalCloudLocation,
      element: (
        <IconContainer>
          <ProcessingIcon text={false} />
          <span>Copying source</span>
        </IconContainer>
      )
    },
    {
      label: 'Releasing',
      value: ImportRequestStatus.CopyingToAirlockInBucket,
      element: (
        <IconContainer>
          <ProcessingIcon text={false} />
          <span>Releasing</span>
        </IconContainer>
      )
    },
    {
      label: 'Available',
      value: ImportRequestStatus.Available,
      element: (
        <IconContainer>
          <ApprovedIcon />
          <span>Available</span>
        </IconContainer>
      )
    },
    {
      label: 'Processing',
      value: ImportRequestStatus.Processing,
      element: (
        <IconContainer>
          <ProcessingIcon text={false} />
          <span>Processing</span>
        </IconContainer>
      )
    },
    {
      label: 'Approved',
      value: ImportRequestStatus.Approved,
      element: (
        <IconContainer>
          <ApprovedIcon />
          <span>Approved</span>
        </IconContainer>
      )
    },
    {
      label: 'Rejected',
      value: ImportRequestStatus.Rejected,
      element: (
        <IconContainer>
          <RejectedIcon />
          <span>Rejected</span>
        </IconContainer>
      )
    },
    {
      label: 'Failed',
      value: ImportRequestStatus.Failed,
      element: (
        <IconContainer>
          <FailedIcon />
          <span>Failed</span>
        </IconContainer>
      )
    }
  ]

  return <CheckboxFilter label="Status" options={options} onApply={onApply} onReset={onReset} withFuzzySearch={false} />
}
